import { FC, useEffect, useState } from "react";
import { getNewsCategories } from "../../../api/transport/newsTransport";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { TeamContext } from "../../../types/common";
import { NewsCategoryDto } from "../../../types/news"

const ALL_CATEGORY: NewsCategoryDto = {
    id: -1,
    name: 'Все',
    nameen: 'all',
    sort: 0,
}

interface NewsCategoriesProps {
    onSelect?: (categodyId: number) => void;
    defaultSelectedId?: number;
}
export const NewsCategories: FC<NewsCategoriesProps> = ({
    onSelect,
    defaultSelectedId = -1,
}) => {
    const config = useConfiguration();
    const [categories, setCategories] = useState<NewsCategoryDto[]>();
    const [selectedCategory, setSelectedCategory] = useState(defaultSelectedId);

    const loadCategories = async () => {
        if (config.teamName !== TeamContext.RODINA) {
            return;
        }

        const data = await getNewsCategories();

        setCategories([ALL_CATEGORY, ...data])
    }

    useEffect(() => {
        setSelectedCategory(defaultSelectedId);
    }, [defaultSelectedId])

    useEffect(() => {
        loadCategories();
    }, []);

    if (!categories?.length) {
        return null;
    }

    return (
        <div className="flex flex-row gap-2 justify-center items-center pb-8 w-full flex-wrap">
            {categories?.map(c => {
                let classNames = "cursor-pointer px-4 py-2 rounded-full active:scale-95 transition-all";

                if (c.id === selectedCategory) {
                    classNames += " text-white bg-sky-950 hover:bg-sky-900";
                } else {
                    classNames += " text-sky-950 bg-gray-100 hover:bg-gray-200";
                }

                return (
                    <div
                        key={c.id}
                        onClick={() => onSelect!(c.id)}
                        className={classNames}
                    >
                        {c.name}
                    </div>
                )
            })}
        </div>
    );
}